import React from "react";
import MaterialTable from "../Tables/MaterialTable";
import { useTranslation } from "react-i18next";
import TitleWithDescription from "../Headers/TitleWithDescription";
import StepsNavButtons from "../Buttons/StepsNavButtons";

const SelectMaterial = ({
    selectedRow,
    setSelectedRow,
    setSelectedRowName = () => {},
    nextStep,
    nextStepButtonText,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="steps step1 show" id="step-one">
                <TitleWithDescription
                    title={t("material")}
                    description={t("selectMaterialParagraph")}
                />
                <MaterialTable
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    setSelectedRowName={setSelectedRowName}
                    nextStep={nextStep}
                />
            </div>
            <StepsNavButtons
                next={{
                    action: nextStep,
                    label: nextStepButtonText,
                    disabled: !selectedRow,
                }}
            />
        </>
    );
};

export default SelectMaterial;
